<template>
  <div>
    <Badge> <i class="pl-0" /> {{ name }} </Badge>
  </div>
</template>

<script setup lang="ts">
import { computed, type PropType } from "vue";
import { useTranslation } from "@/language/translation";
import Badge from "./BadgeComponent.vue";

const props = defineProps({
  user: {
    type: Object as PropType<{ preferredName: string } | null>,
    required: false,
    default: null,
  },
});
const { t } = useTranslation();
const name = computed(() => {
  if (props.user) {
    return props.user.preferredName;
  }
  return t("global.deletedUser");
});
</script>

<style>
.zIndex {
  z-index: 14;
}
</style>
